module.exports = __webpack_public_path__ + "img/finished.7f21528a.png";